export class ResourceEntity {}
